import { Model } from '@/models/Model';
export class Organization extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Organization';
        this.$endpoint = '/organizations';
        this.$fillable = [];
    }
}
export var OrganizationIncludes;
(function (OrganizationIncludes) {
    OrganizationIncludes["CLIENTS"] = "clients";
})(OrganizationIncludes || (OrganizationIncludes = {}));
